/**
 * Alchemy onramp 法币订单：回调后 success 屏文案用。
 * status: CREATED / PAY_SUCCESS / FINISHED / PAY_FAIL / EXPIRED
 */

export const ONRAMP_ORDER_STATUS = {
  CREATED: 'CREATED',
  PAY_SUCCESS: 'PAY_SUCCESS',
  FINISHED: 'FINISHED',
  PAY_FAIL: 'PAY_FAIL',
  EXPIRED: 'EXPIRED',
};

export const ONRAMP_ORDER_POLL_MS = 3_000;
/** 回调后轮询上限：超时退回中性文案 */
export const ONRAMP_ORDER_POLL_MAX_MS = 90_000;

export function normalizeOnrampOrdersPage(data) {
  const rows = Array.isArray(data?.rows)
    ? data.rows
    : Array.isArray(data?.data?.rows)
    ? data.data.rows
    : Array.isArray(data)
    ? data
    : [];
  const total = Number(data?.total ?? data?.data?.total ?? rows.length) || 0;
  return { rows, total };
}

export function normalizeOnrampOrderStatus(status) {
  return String(status ?? '')
    .trim()
    .toUpperCase();
}

export function extractOnrampOrderId(order) {
  return String(
    order?.merchantOrderNo ?? order?.orderId ?? order?.alchemyOrderNo ?? order?.id ?? ''
  ).trim();
}

export function onrampOrderIdsEqual(a, b) {
  const left = String(a ?? '')
    .trim()
    .toLowerCase();
  const right = String(b ?? '')
    .trim()
    .toLowerCase();
  if (!left || !right) return false;
  return left === right;
}

export function findOnrampOrderById(orders, orderId) {
  const list = Array.isArray(orders) ? orders : [];
  const target = String(orderId ?? '').trim();
  if (!target || !list.length) return null;
  return list.find((row) => onrampOrderIdsEqual(extractOnrampOrderId(row), target)) || null;
}

/**
 * success 屏视觉相位（非法币路径不走这里）
 * @returns {'pending'|'pay_success'|'finished'|'failed'|'neutral'}
 */
export function resolveOnrampReturnPhase(status, { timedOut = false } = {}) {
  const s = normalizeOnrampOrderStatus(status);
  if (s === ONRAMP_ORDER_STATUS.FINISHED) return 'finished';
  if (s === ONRAMP_ORDER_STATUS.PAY_FAIL || s === ONRAMP_ORDER_STATUS.EXPIRED) return 'failed';
  if (s === ONRAMP_ORDER_STATUS.PAY_SUCCESS) return 'pay_success';
  if (s === ONRAMP_ORDER_STATUS.CREATED) return 'pending';
  if (timedOut) return 'neutral';
  return 'pending';
}

export function isOnrampReturnTerminalPhase(phase) {
  return phase === 'finished' || phase === 'failed' || phase === 'neutral';
}
